import React, { useEffect, useMemo, useState } from 'react';
import { Search, ChevronRight } from 'lucide-react';
import api from '../services/api';
import Modal from './Modal';
import { ZonaArchivoFactura } from './CargaFacturaIA';

// ============================================================
// Paso previo de las acciones rápidas del Inicio que necesitan un cliente o
// un proveedor (nueva factura, registrar cobranza o pago): lista con
// buscador; al elegir, la pantalla de destino abre la acción directo.
// `conFoto` (factura de compra): arriba, la zona para arrastrar o elegir la
// foto/PDF que lee la IA, que no
// necesita elegir proveedor porque la IA lo reconoce por el RIF.
// ============================================================

const norm = (t) => String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

export default function ElegirParte({ parte, titulo, conFoto = false, onElegir, onFoto, onCerrar }) {
  const [lista, setLista] = useState(null);
  const [busqueda, setBusqueda] = useState('');
  const esCliente = parte === 'cliente';

  useEffect(() => {
    api.get(esCliente ? '/clientes' : '/proveedores')
      .then(({ data }) => setLista(data.filter((x) => Number(x.activo) === 1)))
      .catch(() => setLista([]));
  }, [esCliente]);

  const filtrados = useMemo(() => {
    const q = norm(busqueda.trim());
    const base = lista || [];
    return q ? base.filter((x) => norm(x.nombre).includes(q) || norm(x.rif).includes(q)) : base;
  }, [lista, busqueda]);

  return (
    <Modal title={titulo} onClose={onCerrar} maxWidth="max-w-md">
      {conFoto && (
        <>
          <ZonaArchivoFactura onResultado={onFoto} />
          <p className="text-xs text-slate-500 text-center my-3">o elige el proveedor para cargarla a mano</p>
        </>
      )}
      <div className="relative">
        <Search size={16} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400" />
        <input
          autoFocus={!conFoto}
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
          placeholder={`Buscar ${esCliente ? 'cliente' : 'proveedor'} por nombre o RIF`}
          className="w-full border rounded-md pl-8 pr-3 py-2 text-sm"
        />
      </div>
      <div className="mt-2 max-h-[50vh] overflow-y-auto divide-y divide-slate-100">
        {lista === null ? (
          <p className="py-6 text-center text-sm text-slate-400">Cargando…</p>
        ) : filtrados.length === 0 ? (
          <p className="py-6 text-center text-sm text-slate-400">
            {lista.length === 0 ? `No hay ${esCliente ? 'clientes' : 'proveedores'} activos.` : 'Nada coincide con la búsqueda.'}
          </p>
        ) : (
          filtrados.map((x) => (
            <button
              key={x.id}
              type="button"
              onClick={() => onElegir(x)}
              className="w-full flex items-center justify-between gap-3 px-2 py-2.5 text-left hover:bg-slate-50 rounded-md"
            >
              <span className="min-w-0">
                <span className="block truncate text-sm font-medium text-slate-700">{x.nombre}</span>
                {x.rif && <span className="block text-xs text-slate-400">{x.rif}</span>}
              </span>
              <ChevronRight size={16} className="text-slate-400 shrink-0" />
            </button>
          ))
        )}
      </div>
    </Modal>
  );
}
